/**
 * Every string-resource group the portal needs, fetched once at boot by the
 * APP_INITIALIZER in `app.module.ts`.
 *
 * Translations are a boot-time concern, not a routing concern. This list used to be
 * split between the initializer and a per-route `translationKeys` array feeding a
 * `TranslationResolver`, which meant (a) a failed request cancelled the navigation
 * outright, and (b) any group missing from a route's list rendered as `[KEY]` until
 * the user happened to visit a route that declared it. One list, loaded once, has
 * neither failure mode.
 *
 * Adding a page? Add its groups here.
 */
export const TRANSLATION_GROUPS: readonly string[] = [
  // Shell, navigation and cross-cutting widgets
  'Header',
  'PageMenu',
  'PageTitle',
  'CSO',
  'Dialog',
  'General',
  'GlobalSearch',
  'Settings',
  'Profiles',
  'Impersonation',
  'Unauthorized',
  'ErrorMessages',
  'Days',
  'Culture',
  'Timezone',
  'LengthAbbreviation',
  'VolumeAbbreviation',
  'UnitOfMeasure',

  // Auth
  'Login',
  'ForgotPassword',

  // Grids and filters
  'Column',
  'TankGrid',
  'TankGridHeader',
  'TankFilters',
  'FilterProfile',
  'FilterProfiles',

  // Dashboard
  'Dashboard',
  'TankMap',
  'Charting',

  // Tank
  'TankNav',
  'TankDetails',
  'TankTabs',
  'TankPage',
  'TankHistory',
  'TankSetup',
  'TankConfig',
  'TankChangeHistory',
  'TankBulkConfig',
  'TankSwap',
  'TankProfile',
  'TankProfiles',
  'DFTank',
  'AddInventoryRecord',
  'MoveForms',
  'TankNotifications',
  'EmailAlerts',

  // Location
  'Locations',
  'LocationForm',
  'LocationDetails',
  'DeliveryEfficiencyForecasting',

  // Organization
  'Organizations',
  'OrganizationDetails',
  'OrganizationsMenu',
  'OrganizationFeatures',
  'OrganizationAnomalies',
  'OrganizationEmailAlert',
  'OrganizationsTheming',
  'OrganizationBulkTools',
  'Features',
  'ThemingDetail',

  // User and groups
  'User',
  'UserList',
  'Group',
  'GroupList',

  // Reporting and analytics
  'Reporting',
  'ReportSettings',
  'Analytics',
];
